// extracted by mini-css-extract-plugin
module.exports =  {"progressbar":"VFGydwi","background":"vlM6MFm","progress-fill":"ZqV5fia","progressFill":"ZqV5fia","percentage-label":"_paLzZV","percentageLabel":"_paLzZV"};